import React, { useEffect } from 'react';

import { Container, Header, Footnote, Anchor } from 'Components/core';

import InfoBox from 'Components/InfoBox';

// Images
import complexAndChronic from './images/OE_Page_WhereToGetCare_2.jpeg';
import contactUs from './images/contact-us.jpg';
import everydayCare from './images/OE_Page_WhereToGetCare_1.jpeg';
import familyPlanning from './images/OE_Page_WhereToGetCare_3.jpg';
import AppStoreIOS from 'Images/store-icon-ios.png';
import AppStoreAndroid from 'Images/store-icon-android.png';

// State
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { SubHeader, TitleHeader } from 'Components/core/Header';

 
const renderFooter=(section)=>{
  if(section.footNotes && section.footNotes.length>0)
  {
    return (<Footnote>
      {section.footNotes.map(foot=>{
        return (<div dangerouslySetInnerHTML={{__html:foot.footnote}}></div>);
      })}
    </Footnote>);
  }
};

const getNewSyleData=(state)=>{
  return (<React.Fragment>{state.guidance.resourcesMap.EverydayCare.length>0 && (
    <InfoBox header="Everyday care" image={everydayCare}>
      {state.guidance.resourcesMap.EverydayCare.map(section=>{
        return (   <p>
          <b>{section.name}</b>
          <br />
          <div dangerouslySetInnerHTML={{__html:replaceAnchor(section.summary)}}></div>
          {renderFooter(section)}
        </p>);
      })}
       
    </InfoBox>
  )}
  {state.guidance.resourcesMap.ChronicCare.length>0 && (
    <InfoBox header="Complex and chronic conditions"
      image={complexAndChronic}>
      {state.guidance.resourcesMap.ChronicCare.map(section=>{
        return (   <p>
          <b>{section.name}</b>
          <br />
          <div dangerouslySetInnerHTML={{__html:replaceAnchor(section.summary)}}></div>
          {renderFooter(section)}
        </p>);
      })}
       
    </InfoBox>
  )}
  {state.guidance.resourcesMap.FamilyPlanning.length>0 && (
    <InfoBox  header="Family planning" image={familyPlanning}>
      {state.guidance.resourcesMap.FamilyPlanning.map(section=>{
        return (   <p>
          <b>{section.name}</b>
          <br />
          <div dangerouslySetInnerHTML={{__html:replaceAnchor(section.summary)}}></div>
          {renderFooter(section)}
        </p>);
      })}
       
    </InfoBox>
  )}

  </React.Fragment>);
};

const getOldSyleData=(state)=>{
  return (<React.Fragment>{(state.guidance?.includeNurseLine ||
    state.guidance?.includeAHG ||
    state.guidance?.includeLiveHealthy ||
    state.guidance?.includeShopper ||
    state.guidance?.includeSmartShopper ||
    state.guidance?.includeBlueCard ||
    state.guidance?.includeBlueDistinction ||
    state.guidance?.includeBlueDistinctionTC) && (
    <InfoBox header="Everyday care" image={everydayCare}>
      {state.guidance?.includeNurseLine && (
        <p>
          <b>24/7 NurseLine</b>
          <br />
          You can connect with a registered nurse who’ll answer your
          health questions wherever you are — anytime, day or night. All
          you have to do is call {state.guidance.includeNurseLine}.
        </p>
      )}
      {state.guidance?.includeAHG && (
        <p>
          <b>{state.brandInfo.name} Health Guides</b>
          <br />
          Highly trained associates are like personal support guides who
          can help you with all your health care needs. They can help
          you connect with the right resources, stay on top of the
          screenings and tests you need, find doctors, and more. Reach a
          health guide by calling the number on your member ID card. You
          also can go to {state.guidance.includeAHG} to send a secure
          email.
        </p>
      )}

      {state.guidance?.includeLiveHealthy && (
        <div>
          <p>
            <b>LiveHealth Online</b> <br /> At home, at work or on the
            go, you can have a video visit with a doctor using your
            smartphone, tablet or computer with a webcam. Doctors are
            available 24/7 for advice, treatment and prescriptions if
            needed.* The cost is usually $59 or less, depending on your
            health plan. You also can schedule an appointment to see a
            doctor from the privacy of your home. You’ll pay about the
            same as an in-person office visit. Register at{' '}
            <Anchor code={CODES.WTGC_LHO} to="https://livehealthonline.com">
              livehealthonline.com.
            </Anchor>{' '}
          </p>
          <p>
            * Online prescribing only when appropriate based on
            physician judgment. LiveHealth Online is the trade name of
            Health Management Corporation, a separate company, providing
            telehealth services on behalf of {state.guidance?.includeLiveHealthy}.
          </p>
        </div>
      )}

      {state.guidance?.includeShopper && (
        <p>
          <b>{state.brandInfo.name}Shopper Programs</b>
          <br />
          This is a great way to help you make decisions about expensive
          procedures. Here’s how it works: if you qualify and are
          scheduled for one of the included procedures, like an MRI or
          CT scan, you’ll hear from us about lower-cost alternative
          facilities in your area. We’ll even help you make an
          appointment if you need it. The program is voluntary. You can
          go to any facility you want still, but this way you can make
          an informed choice.
        </p>
      )}

      {state.guidance?.includeSmartShopper && (
        <p>
          <b>SmartShopper</b>
          <br />
          SmartShopper is the consumer shopping and savings program to
          help lower your out-of-pocket cost when you need a medical
          procedure or screening covered under the program. SmartShopper
          earns you a cash reward just for choosing to have your
          procedure at a high-quality location that saves you money. To
          get started, call the SmartShopper Personal Assistant Team at{' '}
          {state.guidance.includeSmartShopper}, or visit{' '}
          <Anchor code={CODES.WTGC_SSC} to="https://smartshopper.com">
            SmartShopper.com.
          </Anchor>{' '}
          and follow the simple prompts.
        </p>
      )}

      {state.guidance?.includeBlueCard && (
        <p>
          <b>BlueCard</b>
          <br />
          Get care while you travel <br />
          Your health plan goes with you when you’re away from home.
          BlueCard® gives you access to urgent care and emergency
          services across the country. Simply call the number on your{' '}
          member ID card. If you’re out of the country,{' '}
          {state.brandInfo.fullname} Core gives you access to doctors
          and hospitals in more than 190 countries. Go to{' '}
          <Anchor code={CODES.WTGC_BCGC} to={'https://bcbsglobalcore.com'}>
            bcbsglobalcore.com
          </Anchor>{' '}
          or download the BCBS Global Core mobile app.
        </p>
      )}

      {state.guidance?.includeBlueDistinction && (
        <p>
          <b>BlueDistinction</b>
          <br />
          Enjoy excellent care, faster recovery <br />
          If you are having surgery or a major procedure like knee or
          hip replacement, look for one of these two designations: Blue
          Distinction Centers or Blue Distinction Centers+. These
          hospitals are recognized for excellent care and faster
          recovery times. Blue Distinction Centers+ are also recognized
          for lower costs. Best of all — you don’t pay extra for access
          to a Blue Distinction Center. It’s part of your plan.
        </p>
      )}

      {state.guidance?.includeBlueDistinctionTC && (
        <p>
          <b>Blue Distinction with Total Care program</b>
          <br />
          Enjoy excellent care, faster recovery <br />
          If you are having surgery or a major procedure like knee or
          hip replacement, look for one of these two designations: Blue
          Distinction Centers or Blue Distinction Centers+. These
          hospitals are recognized for excellent care and faster
          recovery times. Blue Distinction Centers+ are also recognized
          for lower costs. Best of all — you don’t pay extra for access
          to a Blue Distinction Center. It’s part of your plan.
          <br />
          The primary care physicians in our Blue Distinction Total Care
          program take the time to make sure your overall care makes
          sense based on your history, specialists, medications and lab
          results. Plus they offer lots of ways you can get care — like
          phone, email and extended office hours.
        </p>
      )}
    </InfoBox>
  )}

  {(state.guidance?.includeAutism ||
    state.guidance?.includeBHServ ||
    state.guidance?.includeCancerRes ||
    state.guidance?.includeCaseManag ||
    state.guidance?.includeCondCare ||
    state.guidance?.includeCondCareEnd ||
    state.guidance?.includeCondCareSup ||
    state.guidance?.includeDiabetes) && (
    <InfoBox
      header="Complex and chronic conditions"
      image={complexAndChronic}
    >
      {state.guidance?.includeAutism && (
        <p>
          <b>The Autism Spectrum Disorders Program</b>
          <br />
          This unique program focuses on building a strong support
          system for the entire family and making the best choices for
          your child. It includes community resources, coordination of
          care with a case manager and a customized care plan. Call
          1-844-269-0538.
        </p>
      )}
      {state.guidance?.includeBHServ && (
        <p>
          <b>Behavioral health resource</b>
          <br />
          When dealing with behavioral health issues like depression,
          anxiety, substance abuse or eating disorders, extra support
          can make a big difference. Our caring professionals will work
          with you to arrange counseling and support services that meet
          your individual and family needs. Just call 1-866-785-2789.
        </p>
      )}
      {state.guidance?.includeCancerRes && (
        <p>
          <b>Cancer Resources</b>
          <br />
          The Stronger Together website is a great resource for anyone
          facing cancer. You’ll find tools and information that can help
          you make shared treatment decisions, prepare for care or
          develop a care plan, manage symptoms, find caregiving support,
          and more. Visit{' '}
          <Anchor code={CODES.WTGC_CRA} to={'https://cancerresources.anthem.com'}>
            cancerresources.anthem.com.
          </Anchor>{' '}
        </p>
      )}
      {state.guidance?.includeCaseManag && (
        <p>
          <b>Case Management</b>
          <br />
          If you’re coming home after surgery or have a serious health
          condition, a nurse care manager can help answer your questions
          about your follow-up care, medicines and treatment options,
          coordinate benefits for home therapy or medical supplies, and
          find community resources to help you. Your nurse care manager
          will probably call you, but you also can call the Member
          Services number on your ID card.
        </p>
      )}
      {state.guidance?.includeCondCare && (
        <p>
          <b>ConditionCare</b>
          <br />
                 Get support from a dedicated nurse team to manage ongoing conditions like asthma, chronic obstructive pulmonary disorder (COPD), diabetes, heart disease or heart failure. Work with dietitians, health educators and pharmacists who can help you learn about your condition and manage your health. Call the Member Services number on your ID card to get started.
        </p>
      )}
      {state.guidance?.includeCondCareEnd && (
        <p>
          <b>ConditionCare End-stage Renal Disease </b>
          <br />
          If you have end-stage renal disease (ESRD), extra support can
          really help with your day-to-day needs. A registered nurse
          will help you schedule dialysis care and doctor visits; follow
          your treatment plan and understand your medical equipment; and
          find helpful resources and information. You don’t have to do
          anything extra to be part of this program. A nurse will call
          you to see if you want to enroll.
        </p>
      )}
      {state.guidance?.includeCondCareSup && (
        <p>
          <b>ConditionCare Support </b>
          <br />
          If you have lower back pain, vascular disease or a
          musculoskeletal disorder, you can call a nurse care manager
          24/7 for help managing your condition and following your
          doctor’s care plan. You’ll get information that can help you
          avoid hospital stays and time away from work. Plus, it’s
          backed by a team of pharmacists, dietitians and exercise
          specialists. To learn more, call the Member Services number on
          your ID card.
        </p>
      )}
      {state.guidance?.includeDiabetes && (
        <p>
          <b>Diabetes Prevention Program/Solera </b>
          <br />
          This 16-week program can help you lose weight and help reduce
          your risk of developing diabetes. You can choose from a
          variety of support services such as WW® (Weight Watchers) and
          HealthSlate. Many come with a health coach, meal planner,
          scale, weekly lessons and small group support. To learn more,
          go to{' '}
          <Anchor code={CODES.WTGC_INC_DIA} to={`https://${state.guidance?.includeDiabetes}`}>
            {state.guidance?.includeDiabetes}.
          </Anchor>{' '}
        </p>
      )}
      {false && (
        <p>
          <b>OrthoNet</b>
          <br />
          OrthoNet will work with your doctor to help manage your
          physical and occupational therapy needs. We'll help you learn
          about your therapy benefits and what's covered, connect you
          with nearby therapists and make sure you get high-quality,
          cost-effective care.
        </p>
      )}
    </InfoBox>
  )}
  {(state.guidance?.includeFutureMoms == 'FM' ||
    state.guidance?.includeFutureMoms == 'FMLOL' ||
    state.guidance?.includeFertilitySupp) && (
    <InfoBox header="Family planning" image={familyPlanning}>
      {state.guidance?.includeFertilitySupp && [
        <p>
          <b>Fertility Support</b>
          <br />
          If you’re having issues getting pregnant, this program gives
          you the support and resources you need. You’ll get 24/7 access
          to a nurse care manager who can answer questions and connect
          you with specialists in your plan, as well as use of the{' '}
          WINFertility Companion mobile app.
        </p>,
        <Container style={{ alignSelf: 'center' }}>
          <Anchor
            code={CODES.WTGC_FERT_APP_AND}
            to="https://play.google.com/store/apps/details?id=com.win.winfertility&hl=en"
            underline={false}
          >
            <img src={AppStoreAndroid} style={{ width: '175px' }} />
          </Anchor>
          
          <Anchor
            code={CODES.WTGC_FERT_APP_IOS}
            to="https://apps.apple.com/us/app/winfertility-companion/id1286581528"
            underline={false}
          >
            <img src={AppStoreIOS} style={{ width: '175px' }} />
          </Anchor>
        </Container>
      ]}
      {state.guidance?.includeFutureMoms == 'FM' && (
        <p>
          <b>Future Moms</b>
          <br />
          This program can help you take care of yourself and your baby
          before, during and after pregnancy. You can talk to registered
          nurses 24/7 about your pregnancy, newborn care and more. Plus,
          you'll have access to dietitians and social workers, as
          needed. You can earn up to $200 when you complete the Future
          Moms program. Call 1-800-828-5891.
        </p>
      )}

      {state.guidance?.includeFutureMoms == 'FMLOL' && (
        <p>
          <b>Future Moms with LHO</b>
          <br />
          This program can help you take care of yourself and your baby
          before, during and after pregnancy. You can talk to registered
          nurses 24/7 about your pregnancy, newborn care and more. Plus,
          you’ll have access to dietitians and social workers, as
          needed. The program also includes breastfeeding support on
          LiveHealth Online. Call 1-800-828-5891.
        </p>
      )}
    </InfoBox>
  )}</React.Fragment>);
};

export default () => {

  useEffect(()=>{
    Api.recordAcitity(CODES.MENU_WT_GET_CARE);
  },[]);

  return  (
    <Subscribe to={[ApiStore]}>
      {state => {
        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            <TitleHeader>Where 
              <SubHeader>to get care</SubHeader>
            </TitleHeader>
            <p>
          Connect to your best health. Your
            benefits go beyond your medical plan.
            </p>
            {!state.guidance.resourcesMap  && getOldSyleData(state)}
            {state.guidance.resourcesMap  && getNewSyleData(state)}
            {(state.contactUs?.associatesContent ||
            state.contactUs?.getAnswers) && (
              <InfoBox image={contactUs} header="Additional Information">
                <Container column seperation="16px">
                  {state.contactUs?.getAnswers && (
                    <p>
                    If you have questions, it’s easy to get answers. Call the
                    Member Services number on the back of your ID card or use
                    online Message Center at{' '}
                      <Anchor code={CODES.WTGC_WEB} to={state.brandInfo.webLink}>
                        {state.brandInfo.website}
                      </Anchor>{' '}
                    or on your mobile app.
                    </p>
                  )}
                  {state.contactUs?.associatesContent == 'HG1' && (
                    <p>
                      {state.brandInfo.name} Health Guides are here to help you
                    get the most out of your medical plan. These highly trained{' '}
                      {state.brandInfo.name} associates will help you with all
                    your health care needs. Reach a health guide by calling the
                    number on your member ID card. You also can go to{' '}
                      <Anchor  code={CODES.WTGC_WEB}  to={state.brandInfo.webLink}>
                        {state.brandInfo.website}
                      </Anchor>{' '}
                    to send a secure email or chat with them online.
                    </p>
                  )}
                  {state.contactUs?.associatesContent == 'HG2' && (
                    <p>
                      {state.brandInfo.name} Health Guides are here to help you
                    get the most out of your medical plan. These highly trained{' '}
                      {state.brandInfo.name} associates will help you with all
                    your health care needs. Reach a health guide by calling the
                    number on your member ID card. You also can go to{' '}
                      <Anchor  code={CODES.WTGC_WEB}  to={state.brandInfo.webLink}>
                        {state.brandInfo.website}
                      </Anchor>{' '}
                    to send a secure email.
                    </p>
                  )}
                  {state.contactUs?.associatesContent == 'HG3' && (
                    <p>
                      {state.brandInfo.name} Health Guides are here to help you
                    get the most out of your medical plan. These highly trained{' '}
                      {state.brandInfo.name} associates will help you with all
                    your health care needs.
                    </p>
                  )}
                </Container>
              </InfoBox>
            )}
          </Container>
        );
      }}
    </Subscribe>
  );
};